import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  quantityUnits: [],
  quantityUnit: null,
  error: null
};

const foodSlice = createSlice({
  name: "quantityUnit",
  initialState,
  reducers: {
    setQuantityUnits: (state, action) => {
      state.quantityUnits = action.payload;
    },
    setQuantityUnit: (state, action) => {
      state.quantityUnit = action.payload;
    },
    addQuantityUnit: (state, action) => {
      state.quantityUnits.push(action.payload);
    },
    removeQuantityUnit: (state, action) => {
      state.quantityUnits = state.quantityUnits.filter(
        item => item.id !== action.payload.id
      );
    }
  },
  selectors: {
    selectQuantityUnit: state => state.quantityUnit,
    selectQuantityUnits: state => state.quantityUnits
  }
});

export const {
  setQuantityUnit,
  setQuantityUnits,
  addQuantityUnit,
  removeQuantityUnit,
  updateQuantityUnit
} = foodSlice.actions;

export const { selectQuantityUnit, selectQuantityUnits } = foodSlice.selectors;

export default foodSlice.reducer;
